const usuarioClientefacturacionArchetype = [

    // HIDDEN ONES
    {key: 'id_pk', type: 'hidden'},
    {key: 'idcliente_fk', type: 'hidden'},
    {key: 'id_ultimo_usuario_fk', type: 'hidden'},

    
    
    [
        {key: 'idbanco_fk', label: 'Banco'},
        {key: 'formapago', label: 'Forma de pago'},
        // {key: 'tipotarjeta', label: 'Tipo de tarjeta'},
    ],

    // {key: 'numerotarjeta', label: 'Numero de tarjeta'},
    null,
    
    [
        {key: 'rfc'},
        {key: 'razonsocial', label: 'Razón social'}
    ],

    [
        {key: 'factura'},
        {key: 'datos'}
    ],

    null,
    
    // TEXTUALS
    [
        // SELECT
        {key: 'idestado_fk', label: 'Estado'},
        {key: 'ciudad'},
        {key: 'colonia'},
    ],
    {key: 'calle', type: 'textarea'},
    [
        {key: 'numero', label: 'Número'},
        {key: 'codigopostal', label: 'Código Postal'},
    ],
    
];
export { usuarioClientefacturacionArchetype }